import { render, staticRenderFns } from "./SmbLoader.vue?vue&type=template&id=87680e9c&scoped=true&"
import script from "./SmbLoader.vue?vue&type=script&lang=ts&"
export * from "./SmbLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SmbLoader.scss?vue&type=style&index=0&id=87680e9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87680e9c",
  null
  
)

export default component.exports